/**
 * The contracting entity, in one place.
 *
 * "LedgerBox" is the product; this is the company behind it. Three surfaces
 * need the same postal address and they must not drift: the privacy page, the
 * terms page, and the footer of every marketing email, where US law (CAN-SPAM
 * §7704(a)(5)) requires a valid physical address on commercial mail.
 *
 * Here rather than in an environment variable because the failure mode of the
 * env var is silent and legal: unset, the footer simply renders without an
 * address and nothing anywhere says so. `EMAIL_POSTAL_ADDRESS` still overrides
 * it, for the case where the registered address changes before a deploy can.
 */

export const LEGAL_ENTITY_NAME = "Lumen Holdings LLC"

/** Street, locality, country. Rendered as separate lines on the legal pages. */
export const LEGAL_ENTITY_ADDRESS_LINES = [
  "N50W35013 Wisconsin Ave",
  "P.O. Box 111",
  "Okauchee, WI 53069",
  "United States",
] as const

/** The same address on one line, for an email footer. */
export const LEGAL_POSTAL_ADDRESS = `${LEGAL_ENTITY_NAME}, ${LEGAL_ENTITY_ADDRESS_LINES.join(", ")}`
